// extracted by mini-css-extract-plugin
export var deliveryRow = "_rf-a";
export var fixedHeight = "_rf-4";
export var freightLogo = "_rf-9";
export var fullWidth = "_rf-3";
export var priceColumn = "_rf-5";
export var radioSelected = "_rf-7";
export var radioUnselected = "_rf-6";
export var selectedOption = "_rf-2";
export var selectedOptionContainer = "_rf-1";
export var selection = "_rf-0";
export var tallSkeletonText = "_rf-8";